import React from 'react';

const SourceTracker = ({ sources, isVisible }) => {
  if (!isVisible || sources.length === 0) return null;
  
  return (
    <div className="fixed bottom-20 right-4 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 border border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
          Sources Consulted ({sources.length})
        </h3>
        <span className="text-xs text-gray-500">This session</span>
      </div>
      <div className="space-y-2 max-h-60 overflow-y-auto">
        {sources.map((source, idx) => (
          <div key={idx} className="text-xs p-2 bg-gray-50 dark:bg-gray-700 rounded">
            <div className="font-medium text-gray-900 dark:text-white">
              {source.type === 'industry-report' ? '📊' : '📰'} {source.name}
            </div>
            <div className="text-gray-500 dark:text-gray-400">
              {source.database} • {source.date}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SourceTracker;